<template>
<div class="container black">
    <div class="row">
            <div class="col-md-3 offset-md-5">
                <base-button type="primary" href="https://www.jccs.gov/HDPlus/Ext/App?Name=AGATRS" target="popup" onclick="window.open('https://www.jccs.gov/HDPlus/Ext/App?Name=AGATRS','popup','width=600,height=600'); return false;" v-b-popover.hover.left="'Please see Frequently Asked Questions (FAQs) in the Navbar before submitting a HelpDesk ticket.  Many questions will be answered, without the need for a ticket.  Simply search for a keyword or topic.'">
                    <i class="tim-icons icon-light-3"></i> HelpDesk & Feedback
                </base-button>

            </div>
            <div class="col-md-2 offset-md-2 more-top-padding">
                <a class="more-horizontal-padding" href="#" onclick="window.scrollTo(0,0);" v-b-popover.hover.right="'Click to scroll to the top of the page!'"><i class="tim-icons icon-tap-02"></i> Scroll to top</a>
            
            </div>
           
    </div>
    <div class="row">
        <div  class=" col-md-12">
            <div class="align-center">
                Copyright &copy; {{new Date().getFullYear()}} DLA - ACSA Global Automated Tracking & Reporting System
                
            </div>
          
        </div>
    </div>
    <div class=" right_align">
              
              v{{ versionNumber  }}
    
</div>
    <br>
    
   
           
</div>
</template>

<script>
export default {
    name: "Footer",
    data() {
    return {
      versionNumber : process.env.VUE_APP_VERSION
    };
  },
    
};
</script>

<style scoped>
/* more-top-padding makes the links all on the same line */
.more-top-padding {
    padding-top: 1.1em;
}

.container {
    padding-bottom: .25em;
}

.right_align {
position: absolute;
right: 6%;
}
</style>
